module.exports = __webpack_public_path__ + "media/moose.4ddb778b.mp3";